import { AuditProductsReportFilters } from 'src/graphql';

export interface BuildAuditProductsFilterParams {
  storeIds: string[];
  storeIdsSelected?: string[];
  availability?: string | null;
  serviceMode?: string | null;
  override?: string | null;
  isPublished?: string | null;
  channel?: string | null;
  itemType?: string[];
  sectionSelected?: string[];
}

export const buildAuditProductsFilter = ({
  storeIds,
  storeIdsSelected = [],
  availability = null,
  serviceMode = null,
  override = null,
  isPublished = null,
  channel = null,
  itemType = [],
  sectionSelected = [],
}: BuildAuditProductsFilterParams): AuditProductsReportFilters => {
  return {
    storeIds: storeIdsSelected.length > 0 ? storeIdsSelected : storeIds,
    availability: getBoolean(availability),
    serviceMode: serviceMode ?? undefined,
    override: override ?? undefined,
    isPublished: getBoolean(isPublished),
    channel: channel ?? undefined,
    type: itemType.length > 0 ? itemType[0] : undefined,
    section: sectionSelected.length > 0 ? sectionSelected[0] : undefined,
  };
};

const getBoolean = (availability: string | null): boolean | undefined => {
  if (availability === 'true') {
    return true;
  }
  if (availability === 'false') {
    return false;
  }
  return undefined;
};
